export default __webpack_public_path__ + "static/media/c4.6f1c7d35.png";